import { useMemo } from "react";
import DOMPurify from "dompurify";

export default function RichText({ html }) {
  const clean = useMemo(() => {
    return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  }, [html]);

  return (
    <div
      className="prose max-w-none"
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
